import React, { useEffect, useState } from 'react'
import Player from './Player'

import { makeSpotifyRequest } from '../../config/SpotifyRequests'

import { GetPlayer } from '../../hoc/Layout/Layout'
import { useSpotify } from '../../hoc/context/SpotifyContextContainer'
import Error from '../../widgets/error/Error'
 
export default function PlayerContainer({playNext, playPrev}) {
    const { pid, setModal } = GetPlayer();
    const { accessToken } = useSpotify();

    const [ item, setItem ] = useState(null)

    useEffect(async () => {
    
        try {
            if(pid == null) return 
            const song = (await makeSpotifyRequest(`https://api.spotify.com/v1/tracks/${pid}`, accessToken)).data;
            if(song.preview_url){
                setItem({
                    name: song.name,
                    album: song.album.name,
                    image: song.album.images[0].url,
                    preview_url: song.preview_url,
                    uri: song.uri
                })
            }
                if(!song.preview_url){
                    setModal(<Error message={`Track doesn't seem to have a preview.. we'll play the next one for you`} />)
                    playNext();
                }
        }catch(e){
            setModal(<Error message={`Track doesn't have a preview.. please try a different track!`} />)
        }
    }, [pid])

    return (
        <>
          {item && <Player setModal={setModal} item={item} playPrev={playPrev} playNext={playNext} />  }
        </>
    )
}
